import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      marginTop: 32,
      display: "flex",
      "&:last-of-type": {
        marginBottom: 32,
      },
    },
    headerStyle: {
      ...theme.fonts.h4,
      color: theme.colors.textDefault,
    },
    descStyle: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
      marginTop: 8,
    },
    submitButton: {
      marginTop: 16,
      width: "100%",
    },
    removeButton: {
      marginTop: 16,
      width: "100%",
      marginLeft: 0,
      "& > div": { justifyContent: "start" },
    },
    rightContainer: {
      textAlign: "left",
      position: "relative",
      left: 16,
      "& > button": { width: 275 },
    },
    configurationStatus: {
      ...theme.fonts.h4,
      color: theme.colors.textSubtle,
      marginTop: 16,
    },
    configurationStatusDesc: {
      ...theme.fonts.p2,
      color: theme.colors.textSubtle,
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
